import React from 'react'
import {Link} from 'gatsby'

const AgendaFormFilterDatesLink = ({location}) => {
	// Validation des props et gestion des erreurs
	if (location === undefined || location === null) {
		return (
			<div role="region" aria-label="Liens de filtres de dates d'événements" className="agenda-form-filter-dates-link-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : propriété de localisation manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Construction des aria-label pour les liens
	const todayLabel = "Voir les événements d'aujourd'hui"
	const weekLabel = "Voir les événements de cette semaine"
	const weekendLabel = "Voir les événements de ce week-end"
	const containerLabel = location === 'home' ? "Liens de filtres de dates pour la page d'accueil" : "Liens de filtres de dates"

	return (
		<div 
			className={`agenda-filters-dates-buttons${location === 'home' ? ' agenda-filters-home-dates-buttons' : ''}`}
			role="group" 
			aria-label={containerLabel}
			aria-describedby="agenda-form-filter-dates-link-description"
		>
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="agenda-form-filter-dates-link-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				Liens rapides pour filtrer les événements par période
			</div>
			<ul>
			<li><Link 
				className={`agenda-filters-dates-day${location === 'home' ? ' agenda-filters-home-dates-day' : ''}`} 
				to="/agenda/dates/aujourd-hui"
				aria-label={todayLabel}
				aria-describedby="agenda-form-filter-dates-link-description"
			>
				Aujourd'hui
			</Link></li>

			<li><Link 
				className={`agenda-filters-dates-week${location === 'home' ? ' agenda-filters-home-dates-week' : ''}`} 
				to="/agenda/dates/cette-semaine"
				aria-label={weekLabel}
				aria-describedby="agenda-form-filter-dates-link-description"
			>
				Cette semaine
			</Link></li>

			<li><Link 
				className={`agenda-filters-dates-weekend${location === 'home' ? ' agenda-filters-home-dates-weekend' : ''}`} 
				to="/agenda/dates/ce-weekend"
				aria-label={weekendLabel}
				aria-describedby="agenda-form-filter-dates-link-description"
			>
				Ce week-end
			</Link></li>
			</ul>

			{/* Message de statut pour les lecteurs d'écran */}
			<div 
				className="visually-hidden" 
				aria-live="polite" 
				aria-label="Statut des liens de filtres de dates"
			>
				Liens de filtres de dates chargés avec succès
			</div>
		</div>
	)
}

export default AgendaFormFilterDatesLink
